import React from 'react';

import { flagStyles } from '../settings';

const SvgCR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1152px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCR;
